import { ReactCompareSlider, ReactCompareSliderImage, ReactCompareSliderHandle } from "react-compare-slider";
import { Reveal, Eyebrow } from "./Reveal";
import { IMAGES } from "@/lib/images";

const BEFORE_FILTER = "grayscale(0.7) brightness(0.5) sepia(0.4) contrast(0.85) saturate(0.6)";
const AFTER_FILTER = "saturate(1.15) contrast(1.06) brightness(1.02)";

export const BeforeAfter = () => (
  <section id="avant-apres" data-testid="before-after-section" className="py-28 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-12 items-center">
        <Reveal className="lg:col-span-5">
          <Eyebrow>La preuve par l'image</Eyebrow>
          <h2 className="font-display font-black uppercase tracking-tighter leading-[0.95] text-4xl mb-6">
            Avant <span className="text-white/30">/</span> <span className="gold-gradient-text">Après</span>
          </h2>
          <p className="text-base text-white/70 font-light leading-relaxed mb-6">
            Faites glisser le curseur pour constater la différence. Notre traitement antirouille
            stoppe la corrosion causée par le sel des hivers québécois, tandis que notre rénovation
            de carrosserie redonne à la peinture sa profondeur et son lustre d'origine.
          </p>
          <ul className="space-y-3 text-sm text-white/60">
            <li className="flex items-center gap-3">
              <span className="h-1.5 w-1.5 rotate-45 bg-gold inline-block" />
              Protection antirouille durable du châssis et des panneaux
            </li>
            <li className="flex items-center gap-3">
              <span className="h-1.5 w-1.5 rotate-45 bg-gold inline-block" />
              Correction des rayures, tourbillons et oxydation
            </li>
            <li className="flex items-center gap-3">
              <span className="h-1.5 w-1.5 rotate-45 bg-gold inline-block" />
              Fini miroir mesuré à l'éclairage dédié
            </li>
          </ul>
        </Reveal>

        <Reveal delay={0.15} className="lg:col-span-7">
          <div
            data-testid="before-after-slider"
            className="relative rounded-2xl overflow-hidden border border-gold/25 shadow-[0_0_80px_rgba(212,175,55,0.08)] aspect-[16/10]"
          >
            <ReactCompareSlider
              position={55}
              itemOne={
                <div className="relative h-full w-full">
                  <ReactCompareSliderImage src={IMAGES.gwagon} alt="Véhicule avant traitement" style={{ filter: BEFORE_FILTER }} />
                  <span className="absolute top-4 left-4 z-10 rounded-full bg-black/60 backdrop-blur-md border border-white/15 px-4 py-1.5 text-xs uppercase tracking-[0.25em] text-white/80">
                    Avant
                  </span>
                </div>
              }
              itemTwo={
                <div className="relative h-full w-full">
                  <ReactCompareSliderImage src={IMAGES.gwagon} alt="Véhicule après traitement antirouille et rénovation" style={{ filter: AFTER_FILTER }} />
                  <span className="absolute top-4 right-4 z-10 rounded-full bg-gold/90 px-4 py-1.5 text-xs uppercase tracking-[0.25em] text-black font-semibold">
                    Après
                  </span>
                </div>
              }
              handle={
                <ReactCompareSliderHandle
                  buttonStyle={{
                    backdropFilter: "blur(12px)",
                    background: "rgba(212,175,55,0.9)",
                    border: "2px solid #050505",
                    color: "#050505",
                  }}
                  linesStyle={{ background: "#D4AF37", width: 2 }}
                />
              }
              style={{ height: "100%", width: "100%" }}
            />
          </div>
          <p className="mt-4 text-xs text-white/40 tracking-wide">
            Glissez le curseur doré pour comparer — traitement antirouille et rénovation de carrosserie.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
